import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import { EmailLogDetail, EmailLogEntry } from '../models/email-log';

@Injectable({
  providedIn: 'root',
})
export class EmailLogService {
  private http = inject(HttpClient);
  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getEmailLogs(
    page: number,
    pageSize: number,
    emailContext?: string,
    recipientEmail?: string,
  ): Observable<PaginatedResponse<EmailLogEntry>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());

    if (emailContext) {
      params = params.set('email_context', emailContext);
    }

    if (recipientEmail) {
      params = params.set('recipient_email', recipientEmail);
    }

    return this.http.get<PaginatedResponse<EmailLogEntry>>(
      `${this.adminApiBaseUrl}/emails/log`,
      { params },
    );
  }

  getEmailLogContexts(): Observable<{ option: string; value: string }[]> {
    return this.http.get<{ option: string; value: string }[]>(
      `${this.adminApiBaseUrl}/emails/log/contexts`,
      { headers: { 'X-Skip-Loader': 'true' } },
    );
  }

  getEmailLogDetail(id: number): Observable<EmailLogDetail> {
    return this.http.get<EmailLogDetail>(
      `${this.adminApiBaseUrl}/emails/log/${id}`,
      {
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
}
